<template>
  <div>
    <v-tabs
      v-model="active"
      center-active
      :class="{
        'px-0': $vuetify.breakpoint.smAndUp,
      }"
      show-arrows
      background-color="colorDominant colorTabs"
    >
      <v-tab v-on:click="allEvents">Todos</v-tab>
      <v-tab
        v-for="(day, index) in tabs"
        :key="index + '-' + day.name"
        v-on:click="getDataByDay(day.value)"
        :href="`#tab-${index + 1}`"
      >
        {{ day.name }}
      </v-tab>
    </v-tabs>
  </div>
</template>

<script>
import { icon } from "@/components/icon-sport/icon.js";

Date.prototype.addDays = function (days) {
  var date = new Date(this.valueOf());
  date.setDate(date.getDate() + days);
  return date;
};

export default {
  name: "toolbar-tab-days",
  props: ["data"],
  data: (vm) => {
    return {
      active: "tab-0",
      dataLocal: vm.data,
      days: [],
      filterByDay: {},
      loading: false,
      tabs: [],
    };
  },

  watch: {
    data(val) {
      if (val == undefined) return;
      // Reset Layout
      this.active = "tab-0";
      this.$emit("set", 0);
      this.filterByDay = {};
      // End reset layout
    },
  },

  mounted() {
    this.buildTabs();
  },

  methods: {
    buildTabs() {
      const date = new Date();
      for (let i = 0; i < this.$store.state.operators.table_days; ++i) {
        this.days.push(date.addDays(i).getDate());
      }

      const lengthCurrentMonth = `${date.getMonth() + 1}`.split("").length;
      const valueMonth =
        lengthCurrentMonth == 1
          ? `0${date.addDays(1).getMonth() + 1}`
          : `${date.addDays(2).getMonth() + 1}`;

      const days = [];

      for (let i = 0; i < this.days.length; ++i) {
        days.push({
          name: `${this.days[i]}/${valueMonth}`,
          value: this.days[i],
          active: false,
        });
      }

      if (date.addDays(0).getDate() == this.days[0]) {
        days[0].name = "Hoje";
      }

      this.tabs = days;
    },

    allEvents() {
      const data = JSON.parse(localStorage.data_events);
      this.$store.commit("data_events", data);
    },

    getDataByDay(day) {
      const _this = this;
      this.$store.commit("data_events", []);

      // setTimeout(() => {
      // Dado geral setado no localStorage
      const data = JSON.parse(localStorage.data_events);

      // Filtra os eventos por data
      let arr = [];
      for (const item of data.all) {
        for (const [index, t] of item.tournaments.entries()) {
          t.events = t.events.filter((e) => {
            return (
              new Date(e.scheduled.replace(" ", "T")).getDate() == day &&
              t.events.length != 0
            );
          });
          if (t.events.length != 0) {
            arr.push(item);
          }
        }
      }

      // Apos o filtro de events caso o array de eventos for zero
      // aqui ele remove os torneios sem events
      for (const el of arr) {
        el.tournaments = el.tournaments.filter((t) => t.events.length != 0);
      }

      // Remove paises repetidos
      var resArr = [];
      arr.filter(function (item) {
        var i = resArr.findIndex((x) => x.id == item.id);
        if (i <= -1) {
          resArr.push(item);
        }
        return null;
      });

      const data_events = {
        all: resArr,
        filtred: [],
      };

      console.log(data_events);
      // Seta o valor no vuex para mostrar na tabela
      this.$store.commit("data_events", data_events);
      // }, 1000);
    },
    // Implementa o Icon correto por Sport
    iconT: function (id) {
      return icon(id);
    },
  },
};
</script>